import { taskCommentsApiRoutes } from './api-routes';

export const taskCommentsQueryKeys = {
    all: ['task-comments'] as const,
    list: (taskId: string) =>
        [...taskCommentsQueryKeys.all, taskCommentsApiRoutes.getTaskCommentsRoute(taskId)] as const,
    create: (taskId: string) => [...taskCommentsQueryKeys.list(taskId), 'create'] as const,
    poll: (taskId: string) => [...taskCommentsQueryKeys.list(taskId), 'poll'] as const,
    delete: (taskId: string) => [...taskCommentsQueryKeys.list(taskId), 'delete'] as const,
};
